import logger from "../../logger";
import setSelectedPayerId from "../StateSetters/setSelectedPayerId";

export default function selectDefaultPayer(data: any, stateHandler: any) {
  logger.log(data);
  // Set the payer id of the first payer
  setSelectedPayerId(data[0].payer_data.payer_id, stateHandler);
}
